import React from "react";
import { Modal, Form, Select, DatePicker, Input, Button, Col, Row } from "antd";
import dayjs from "dayjs";
import moment from "moment";
import { postReq } from "../api";

const { TextArea } = Input;

export default function AddOutreachModal({ open, onClose, spocId, onSuccess }) {
  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    const payload = {
      spocId,
      channel: values.channel,
      stage: values.stage,
      status: values.status,
      contactedAt: values.contactedAt.toISOString(),
      nextFollowUpAt: values.nextFollowUpAt
        ? values.nextFollowUpAt.toISOString()
        : null,
      remark: values.remark || "",
    };

    await postReq("/common/outreach", { ...payload });

    form.resetFields();
    onClose();
    onSuccess(); // refresh timeline/table
  };

  const contactedAt = Form.useWatch("contactedAt", form);

  return (
    <Modal
      open={open}
      title="Add Outreach"
      onCancel={onClose}
      footer={null}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{
          contactedAt: moment(),
        }}
      >
        <Form.Item name="channel" label="Channel" rules={[{ required: true }]}>
          <Select
            options={[
              { value: "EMAIL", label: "Email" },
              { value: "PHONE", label: "Phone" },
              { value: "LINKEDIN", label: "LinkedIn" },
            ]}
          />
        </Form.Item>

        <Form.Item name="stage" label="Stage" rules={[{ required: true }]}>
          <Select
            options={[
              { value: "INTRO", label: "Intro" },
              { value: "FU1", label: "Follow-up 1" },
              { value: "FU2", label: "Follow-up 2" },
              { value: "FU3", label: "Follow-up 3" },
              { value: "REPLIED", label: "Replied" },
            ]}
          />
        </Form.Item>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="contactedAt"
              label="Contacted On"
              rules={[{ required: true }]}
            >
              <DatePicker
                disabledDate={(current) =>
                  current && current > moment().endOf("day")
                }
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="nextFollowUpAt" label="Next Follow-up">
              <DatePicker
                disabledDate={(current) => {
                  if (!contactedAt) return false;

                  return current && current <= moment(contactedAt).endOf("day");
                }}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item name="status" label="Status">
          <Select
            allowClear
            options={[
              { value: "PENDING", label: "Pending" },
              { value: "IN_DISCUSSION", label: "In Discussion" },
              { value: "REPLIED", label: "Replied" },
              { value: "NOT_INTERESTED", label: "Not Interested" },
            ]}
          />
        </Form.Item>

        <Form.Item name="remark" label="Remark">
          <TextArea rows={3} placeholder="Optional notes…" />
        </Form.Item>

        <Button type="primary" htmlType="submit" block>
          Save Outreach
        </Button>
      </Form>
    </Modal>
  );
}
